import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

/**
 * Reusable Delete Confirmation Dialog Component
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {Function} props.onClose - Function to call when dialog is closed
 * @param {Function} props.onConfirm - Function to call when delete is confirmed
 * @param {string} props.title - Optional custom title (defaults to delete confirmation)
 * @param {string} props.message - Optional custom message
 * @param {string} props.buttonLabel - Optional custom button label
 * @param {boolean} props.isLoading - Whether the delete operation is in progress
 */
const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Delete Confirmation',
  message = 'Are you sure you want to delete this goal and all related data?',
  buttonLabel = 'Delete',
  isLoading = false,
}) => {
  return (
    <Dialog
      sx={{ zIndex: 9999 }}
      open={open}
      onClose={isLoading ? undefined : onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent>
        <Typography
          sx={{
            color: 'var(--clr-theme-gray)',
            fontFamily: 'Karla',
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={onClose}
          color='primary'
          disabled={isLoading}
          sx={{
            color: 'var(--clr-theme-purple)',
            border: '1px solid var(--clr-theme-purple)',
          }}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={onConfirm}
          color='error'
          autoFocus
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} color='inherit' />
              Deleting...
            </>
          ) : (
            buttonLabel
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
